import React from 'react'

import styled from 'styled-components'

import { devices, margins } from './'


export const Title = styled.div`
    font-size: 34px;
    text-decoration: underline;
    ${({ marginbottom }) => marginbottom && `margin-bottom: ${marginbottom}px;`}
    /* width: 25%; */
    min-width: 180px;
    margin-right: 50px;

    @media ${devices.mobile} {
        margin-bottom: 50px;
        width: 100%;
    }
`

export const Header = ({ as='div', ...rest }) => {
    return React.createElement(styled(as).attrs(() => rest)`
        font-weight: 700;
        max-width: ${props => props.unsetmaxwidth ? 'unset' : '690px'};
        line-height: 1.2;
        font-size: ${({ fontSize=44 }) => fontSize}px;
        ${margins}
        @media ${devices.mobile} {
           font-size: 25px;
        }
    `)
}

export const UpperHeader = styled.h2`
    font-size: ${({ fontSize=16 }) => fontSize}px;
    color: ${({ color='inherit' }) => color};
    font-weight: 200;
    letter-spacing: 2px;
    text-transform: uppercase;
    ${margins}
    @media ${devices.mobile} {
       font-size: 16px;
    }
`

export const UnstyledLink = ({ as='a', ...rest }) => {
    const component = styled(as).attrs(() => rest)`
        cursor: pointer;
        color: inherit;
        text-decoration: none;
        &:hover, &:focus, &:active, &:visited {
            color: inherit;
        }
    `

    return React.createElement(component, rest)
}
